import { render } from "./AttendeesTable.vue?vue&type=template&id=2b1df502"
import script from "./AttendeesTable.vue?vue&type=script&lang=js"
export * from "./AttendeesTable.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__